import { Product } from "components/commons";
import { DipstickInputV2 } from "modules/shift-records/shift-records-details/shift-details-stock-inventory-dipstick-input";
import styles from "../purchase-order.module.scss";
import { DeleteOutline, InfoOutlined } from "@material-ui/icons";
import Big from "big.js";
import { stringToDecimal } from "utils/text.utils";
import { prettifyProductCode } from "utils/pretty.utils";
import { formatNumber, formatVolume } from "utils";
import { ProductCodeEnum } from "enums";
import locale from "localization";
import TooltipBubble from "components/commons/tooltip/tooltip-bubble.module";

export const setVariance = ({
  quantityBeforeReceivingNumber = 0,
  quantityDeliveredNumber = 0,
  quantityAfterReceivingNumber = 0,
}) => {
  quantityBeforeReceivingNumber = stringToDecimal(quantityBeforeReceivingNumber || 0);
  quantityDeliveredNumber = stringToDecimal(quantityDeliveredNumber || 0);
  quantityAfterReceivingNumber = stringToDecimal(quantityAfterReceivingNumber || 0);

  return Big(quantityAfterReceivingNumber)
    .minus(Big(quantityBeforeReceivingNumber).add(quantityDeliveredNumber))
    .toNumber();
};

export const getQuantityAfterReceiving = (quantityBeforeReceiving, quantityDelivered) => {
  quantityBeforeReceiving = stringToDecimal(quantityBeforeReceiving || 0);
  quantityDelivered = stringToDecimal(quantityDelivered || 0);

  return Big(quantityBeforeReceiving).plus(quantityDelivered);
};

export const mapDataToListFuel = ({
  products,
  productsOptions = [],
  modifyField,
  modifyForm,
  onRemove,
  fieldsAsRows,
  formMode,
}) => {
  // const sku = fieldsAsRows[products.id].sku;
  const product = fieldsAsRows[products.id].product;
  const inventoryLevelCm = fieldsAsRows[products.id].inventoryLevelCm;
  const inventoryLevelLiter = fieldsAsRows[products.id].inventoryLevelLiter;
  const volume = fieldsAsRows[products.id].volume;
  const isInventoryFromTotalizerData = fieldsAsRows[products.id]?.isInventoryFromTotalizer;
  const totalizerValue = fieldsAsRows[products.id]?.totalizerValue?.value;

  const isInventoryUseTotalizer =
    stringToDecimal(inventoryLevelLiter?.value) === stringToDecimal(totalizerValue);

  return {
    product: <div style={{ marginTop: "2em" }}>{product?.value}</div>,
    currentInventoryLevel: (
      <div className={styles.inputRow}>
        <div
          style={{ display: "flex", alignItems: "center", gap: "1rem", justifyContent: "center" }}
        >
          <DipstickInputV2
            fields={inventoryLevelCm}
            unit={"mm"}
            placeholder={"0"}
            modifyField={modifyField}
            className={styles.dipstick}
            classNameInput={styles.dipstickTextField}
            classNameMessage={styles.lastItem}
          />
          <div>/</div>
          <DipstickInputV2
            fields={inventoryLevelLiter}
            unit={"L"}
            decimalPlaces={3}
            placeholder={"0"}
            modifyField={(name, { value }) => {
              const inventoryLiterVal = stringToDecimal(value);
              modifyForm({
                [name]: {
                  value: value,
                },
                [isInventoryFromTotalizerData.name]: {
                  value: totalizerValue === inventoryLiterVal,
                },
              });
            }}
            className={styles.dipstick}
            classNameInput={styles.dipstickTextField}
            classNameMessage={styles.lastItem}
          />
          {isInventoryUseTotalizer ? (
            <span style={{ marginLeft: 8, display: "flex", alignItems: "center" }}>
              <TooltipBubble content={locale.inventoryText}>
                <InfoOutlined
                  style={{
                    cursor: "pointer",
                    color: "#5349b7",
                    fontSize: "1.7em",
                    marginLeft: "4px",
                  }}
                />
              </TooltipBubble>
            </span>
          ) : null}
        </div>
      </div>
    ),
    orderedVolume: (
      <DipstickInputV2
        fields={volume}
        unit={"L"}
        decimalPlaces={3}
        placeholder={"0"}
        modifyField={modifyField}
        className={styles.dipstick}
        classNameInput={styles.dipstickTextField}
        classNameMessage={styles.lastItem}
      />
    ),
    actions: <DeleteOutline style={{ color: "#5349b7" }} onClick={() => onRemove?.(products.id)} />,
  };
};

export const mapDataToListViewFuel = ({ orders, allProducts = [] }) => {
  const productCode = orders?.productCode;
  const inventoryLevelCm = orders?.inventoryLevelCm;
  const inventoryLevelLiter = orders?.inventoryLevelLiter;
  const volume = orders?.volume;
  const isInventoryUseTotalizer = orders?.isInventoryFromTotalizer || false;

  return {
    product: (
      <div style={{ margin: "10px 0px" }}>
        <Product
          key={productCode}
          grass={productCode === ProductCodeEnum.GAS91}
          salsa={productCode === ProductCodeEnum.GAS95}
          deepBlue={productCode === ProductCodeEnum.GAS97}
          cheddar={productCode === ProductCodeEnum.DIESEL}
        >
          {prettifyProductCode(productCode)}
        </Product>
      </div>
    ),
    currentInventoryLevel: (
      <div className={styles.inputRow}>
        {formatVolume(inventoryLevelCm, "mm", 4)} / {formatVolume(inventoryLevelLiter)}
        {isInventoryUseTotalizer ? (
          <span style={{ marginLeft: 8, display: "flex", alignItems: "center" }}>
            <TooltipBubble content={locale.inventoryText}>
              <InfoOutlined
                style={{
                  cursor: "pointer",
                  color: "#5349b7",
                  fontSize: "1.7em",
                  marginLeft: "4px",
                }}
              />
            </TooltipBubble>
          </span>
        ) : null}
      </div>
    ),
    orderedVolume: formatVolume(volume),
  };
};
